import moment from "moment";

export const convertUtcToLocal = (date, format = 'YYYY-MM-DD HH:mm') => {
    return moment.utc(date).local().format(format);
};
